import axios from 'axios'
const BASE_URL = `${import.meta.env.VITE_STUDENT_IAM_URL}`

export const validateToken = (token) => {
  try {
    return axios.get(`${BASE_URL}/auth/validate-token`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      'Content-Type': 'application/json',
    })
  } catch (error) {
    throw new Error('Error validating token')
  }
}

export const refreshAccessToken = () => {
  try {
    return axios.get(`${BASE_URL}/auth/refresh-access-token`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
      'Content-Type': 'application/json',
    })
  } catch (error) {
    throw new Error('Error refreshing access token')
  }
}

export const logoutFromGoogle = () => {
  try {
    return axios.get(`${BASE_URL}/auth/logout`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
      'Content-Type': 'application/json',
    })
  } catch (error) {
    throw new Error('Error logging out from Google')
  }
}

export const updateUserData = (userData) => {
  try {
    return axios.put(
      `${BASE_URL}/api/v1/iam/info/user/update`, // Adjust endpoint as needed
      userData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          'Content-Type': 'application/json',
        },
      }
    )
  } catch (error) {
    throw new Error('Error updating user data')
  }
}

export const getUserInfoByID = () => {
  try {
    return axios.get(`${BASE_URL}/api/v1/iam/info/user-by-id`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
      },
    })
  } catch (error) {
    throw new Error('Error getting user info by ID')
  }
}
